import { render, staticRenderFns } from "./fap.vue?vue&type=template&id=6e63f84c&scoped=true&"
import script from "./fap.vue?vue&type=script&lang=js&"
export * from "./fap.vue?vue&type=script&lang=js&"
import style0 from "./fap.vue?vue&type=style&index=0&id=6e63f84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e63f84c",
  null
  
)

export default component.exports